
import {
  addDoc,
  collection,
  deleteDoc,
  doc,
  getDoc,
  serverTimestamp,
  updateDoc,
} from 'firebase/firestore';

import { db } from '../firebase';

import {
  addExpenseToStats,
  addIncomeToStats,
  addInvoiceToStats,
  addPaymentToStats,
  removeExpenseFromStats,
  removeIncomeFromStats,
  removeInvoiceFromStats,
  removePaymentFromStats,
  updateExpenseInStats,
  updateIncomeInStats,
  updateInvoiceInStats,
  updatePaymentInStats,
} from './statsService';

export async function createInvoiceWithStats(invoiceData) {
  const payload = {
    ...invoiceData,
    createdAt: invoiceData?.createdAt || serverTimestamp(),
    updatedAt: serverTimestamp()
  };

  const ref = await addDoc(collection(db, 'invoices'), payload);
  await addInvoiceToStats(payload);
  return ref.id;
}

export async function updateInvoiceWithStats(invoiceId, nextInvoiceData) {
  const ref = doc(db, 'invoices', invoiceId);
  const previous = await getDoc(ref);
  const prevData = previous.exists() ? previous.data() : null;

  const payload = {
    ...nextInvoiceData,
    updatedAt: serverTimestamp(),
  };

  await updateDoc(ref, payload);
  if (prevData) {
    await updateInvoiceInStats(prevData, payload);
  } else {
    await addInvoiceToStats(payload);
  }
}

export async function deleteInvoiceWithStats(invoiceId) {
  const ref = doc(db, 'invoices', invoiceId);
  const previous = await getDoc(ref);
  const prevData = previous.exists() ? previous.data() : null;

  await deleteDoc(ref);
  if (prevData) {
    await removeInvoiceFromStats(prevData);
  }
}

export async function createIncomeWithStats(data) {
  const payload = {
    ...data,
    createdAt: data?.createdAt || serverTimestamp(),
    updatedAt: serverTimestamp()
  };

  const ref = await addDoc(collection(db, 'income'), payload);
  await addIncomeToStats(payload);
  return ref.id;
}

export async function updateIncomeWithStats(id, nextData) {
  const ref = doc(db, 'income', id);
  const previous = await getDoc(ref);
  const prevData = previous.exists() ? previous.data() : null;

  const payload = {
    ...nextData,
    updatedAt: serverTimestamp(),
  };

  await updateDoc(ref, payload);
  if (prevData) {
    await updateIncomeInStats(prevData, payload);
  } else {
    await addIncomeToStats(payload);
  }
}

export async function deleteIncomeWithStats(id) {
  const ref = doc(db, 'income', id);
  const previous = await getDoc(ref);
  const prevData = previous.exists() ? previous.data() : null;

  await deleteDoc(ref);
  if (prevData) {
    await removeIncomeFromStats(prevData);
  }
}

export async function createExpenseWithStats(data) {
  const payload = {
    ...data,
    createdAt: data?.createdAt || serverTimestamp(),
    updatedAt: serverTimestamp()
  };

  const ref = await addDoc(collection(db, 'expenses'), payload);
  await addExpenseToStats(payload);
  return ref.id;
}

export async function updateExpenseWithStats(id, nextData) {
  const ref = doc(db, 'expenses', id);
  const previous = await getDoc(ref);
  const prevData = previous.exists() ? previous.data() : null;

  const payload = {
    ...nextData,
    updatedAt: serverTimestamp(),
  };

  await updateDoc(ref, payload);
  if (prevData) {
    await updateExpenseInStats(prevData, payload);
  } else {
    await addExpenseToStats(payload);
  }
}

export async function deleteExpenseWithStats(id) {
  const ref = doc(db, 'expenses', id);
  const previous = await getDoc(ref);
  const prevData = previous.exists() ? previous.data() : null;

  await deleteDoc(ref);
  if (prevData) {
    await removeExpenseFromStats(prevData);
  }
}

export async function createPaymentWithStats(data) {
  const payload = {
    ...data,
    createdAt: data?.createdAt || serverTimestamp(),
    updatedAt: serverTimestamp()
  };

  const ref = await addDoc(collection(db, 'payments'), payload);
  await addPaymentToStats(payload);
  return ref.id;
}

export async function updatePaymentWithStats(id, nextData) {
  const ref = doc(db, 'payments', id);
  const previous = await getDoc(ref);
  const prevData = previous.exists() ? previous.data() : null;

  const payload = {
    ...nextData,
    updatedAt: serverTimestamp(),
  };

  await updateDoc(ref, payload);
  if (prevData) {
    await updatePaymentInStats(prevData, payload);
  } else {
    await addPaymentToStats(payload);
  }
}

export async function deletePaymentWithStats(id) {
  const ref = doc(db, 'payments', id);
  const previous = await getDoc(ref);
  const prevData = previous.exists() ? previous.data() : null;

  await deleteDoc(ref);
  if (prevData) {
    await removePaymentFromStats(prevData);
  }
}
